var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectsPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Primary",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ProjectPage_White",
    "data-name": "Icon/ProjectPage/White",
    transform: "translate(-305.738 -151.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M314.1,153.082c.187.257.164.474-.128.631a10.89,10.89,0,0,0-3.171,2.574c-.132.155-.323.34-.526.162-.221-.2-.09-.417.076-.607a11.5,11.5,0,0,1,2.694-2.316c.205-.125.492-.165.586-.444Z",
    transform: "translate(-1.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M328.2,153.082c.717.159,1.434.315,2.15.479.234.053.507.138.434.434s-.38.238-.594.173a13.469,13.469,0,0,0-2.6-.432c-.489-.049-.6-.247-.324-.654Z",
    transform: "translate(-9.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M315.233,166.795a6.236,6.236,0,1,1,6.209,6.276A6.291,6.291,0,0,1,315.233,166.795Zm6.244-5.577a5.615,5.615,0,1,0,5.577,5.632A5.6,5.6,0,0,0,321.476,161.218Z",
    transform: "translate(-3.747 -3.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M310.231,165.045a8.875,8.875,0,0,1,5.973-8.655c.241-.083.585-.352.72.075.123.387-.288.436-.535.523a7.789,7.789,0,0,0-4.863,4.517,7.87,7.87,0,0,0,1.316,8.448c.1.12.216.226.315.346.131.162.3.344.063.533-.205.163-.383.044-.539-.123a8.947,8.947,0,0,1-1.691-2.5A8.477,8.477,0,0,1,310.231,165.045Z",
    transform: "translate(-1.246 -1.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M338.638,166.726a8.759,8.759,0,0,1-5.638,8.2c-.283.11-.68.445-.861-.007-.163-.41.341-.445.6-.549a7.881,7.881,0,0,0,5.042-5.883,7.775,7.775,0,0,0-1.618-6.792c-.161-.2-.339-.394-.507-.593-.128-.153-.2-.331-.024-.481a.319.319,0,0,1,.479.078c.322.374.662.736.947,1.137A8.777,8.777,0,0,1,338.638,166.726Z",
    transform: "translate(-12.185 -3.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M326,160.618a1.237,1.237,0,0,1-.219.25c-.2.123-.348-.027-.482-.14a9.265,9.265,0,0,0-1.5-1.1,6.828,6.828,0,0,0-9.639,3.421,1.246,1.246,0,0,1-.072.221c-.142.213-.151.656-.552.484s-.117-.5-.029-.733a7.453,7.453,0,0,1,12.134-2.818C325.769,160.32,325.871,160.466,326,160.618Z",
    transform: "translate(-2.795 -2.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M322.435,182.443a7.591,7.591,0,0,1-4.915-1.852c-.19-.167-.6-.314-.318-.658s.521.024.716.182a6.685,6.685,0,0,0,7.274,1.07,6.561,6.561,0,0,0,3.449-3.438c.087-.187.137-.392.23-.576s.193-.418.46-.293c.244.114.184.34.113.543a7.22,7.22,0,0,1-1.6,2.642A7.56,7.56,0,0,1,322.435,182.443Z",
    transform: "translate(-4.684 -11.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M343.848,165.223c.016.335,0,.623-.282.647-.384.032-.342-.326-.354-.566a9.374,9.374,0,0,0-2.234-5.756c-.2-.237-.427-.454-.637-.683-.17-.186-.44-.376-.166-.646.252-.248.425.027.578.176a9.792,9.792,0,0,1,2.974,5.758C343.783,164.539,343.815,164.927,343.848,165.223Z",
    transform: "translate(-16.16 -2.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M308.023,172.486c.259.025.33.2.34.429a9.829,9.829,0,0,0,1.626,5.117c.135.2.243.466-.029.608s-.394-.137-.522-.327a10.017,10.017,0,0,1-1.687-5.18C307.738,172.882,307.676,172.6,308.023,172.486Z",
    transform: "translate(0 -9.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M321.935,190.994a9.971,9.971,0,0,1-4.35-1.245c-.206-.115-.566-.2-.411-.543s.442-.16.66-.035a9.865,9.865,0,0,0,4.228,1.206c.261.019.668-.059.618.373C322.641,191.075,322.3,191.025,321.935,190.994Z",
    transform: "translate(-4.699 -17.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M341.187,186.488a4.45,4.45,0,0,1-.264.4,10.872,10.872,0,0,1-3.176,2.592c-.2.111-.442.289-.612.016s.064-.425.278-.542a11.2,11.2,0,0,0,3.112-2.55c.117-.137.262-.282.466-.161C341.068,186.287,341.112,186.39,341.187,186.488Z",
    transform: "translate(-14.67 -16.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M338.608,186.657c-.07-.044-.187-.078-.227-.152a.316.316,0,0,1,.1-.414,13.681,13.681,0,0,0,2.04-2.015.306.306,0,0,1,.477-.044c.149.13.106.282.006.413a10.886,10.886,0,0,1-2.148,2.122A1.045,1.045,0,0,1,338.608,186.657Z",
    transform: "translate(-15.302 -15.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M311.789,159.539c-.292-.052-.394-.23-.2-.484a10.274,10.274,0,0,1,2.081-2.081.272.272,0,0,1,.409.034.261.261,0,0,1,.024.356,28.258,28.258,0,0,0-2.139,2.135C311.931,159.529,311.862,159.523,311.789,159.539Z",
    transform: "translate(-1.875 -1.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M314.583,186.913c-.058.193-.2.411-.415.255a5.928,5.928,0,0,1-1.4-1.306c-.126-.173.018-.34.241-.368A4.463,4.463,0,0,1,314.583,186.913Z",
    transform: "translate(-2.493 -16.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M336.132,155.191a5.5,5.5,0,0,1,1.487.962.18.18,0,0,1-.029.271c-.092.081-.209.18-.343.1-.441-.26-.881-.525-1.311-.8a.242.242,0,0,1-.053-.346A.982.982,0,0,1,336.132,155.191Z",
    transform: "translate(-14.048 -1.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M327.856,189.778c-.316-.008-.686.1-.708-.308-.02-.376.351-.277.585-.324a.265.265,0,0,1,.077-.007c.391.036,1.055-.375,1.091.237C328.932,189.9,328.182,189.611,327.856,189.778Z",
    transform: "translate(-9.705 -17.977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M325.775,155.62c.336-.01.707-.074.709.322,0,.342-.371.318-.61.3-.406-.032-1.094.436-1.145-.238C324.691,155.5,325.456,155.781,325.775,155.62Z",
    transform: "translate(-8.495 -1.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M346.6,182.76a4.121,4.121,0,0,1-.708,1.138.224.224,0,0,1-.282.048.277.277,0,0,1-.137-.334,2.946,2.946,0,0,1,.612-1.068.228.228,0,0,1,.345-.025A1.264,1.264,0,0,1,346.6,182.76Z",
    transform: "translate(-18.862 -14.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M341.939,173.195c-.13.245.122.775-.4.813-.308.022-.342-.352-.272-.6.086-.31-.132-.828.388-.866C341.977,172.513,341.955,172.883,341.939,173.195Z",
    transform: "translate(-16.75 -9.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M308.137,162.078c-.213-.015-.337-.081-.363-.271-.035-.247.593-1.182.793-1.161.172.018.319.139.269.307A2.053,2.053,0,0,1,308.137,162.078Z",
    transform: "translate(-0.017 -3.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M313.368,171.352c-.062.305.111.759-.313.781-.462.023-.322-.428-.315-.706.008-.311-.08-.788.393-.759C313.5,170.69,313.339,171.117,313.368,171.352Z",
    transform: "translate(-2.488 -8.793)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_677",
    "data-name": "Rectangle 677",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsPage);
export default __webpack_public_path__ + "static/media/ProjectsPage.3267a0f2.svg";
export { ForwardRef as ReactComponent };